<p-toast position="top-right" key="save"></p-toast>
<div class="fixed transform z-5" *ngIf="showProgressSpinner">
  <app-custom-spinner></app-custom-spinner>
</div>
<div class="fixed transform" style="z-index: 1200;" *ngIf="showsharedProgressSpinner">
  <app-custom-spinner></app-custom-spinner>
</div>
<div class="bg-default px-3 pb-3" id="htmldata" #htmldata>
  <div class="flex justify-content-between align-items-center title-bg title-case" style="margin-bottom: 5px;">
    <div class="conten">
      <div class="btn"><a>Improve</a></div>
    </div>
  </div>
  <div class="grid justify-content-end">
    <div class="col-12 md:col-6 lg:col-2">
      <label for="FirstName"
        [ngStyle]="filterTypeErrorBool ? {'color':'red','font-size':'15px'} : {'color':'black'}"><b>Filter
          Type</b></label>
      <p-dropdown [options]="selectedFacilityOptions" [(ngModel)]="selectedFilterType" placeholder="Select Filter Type"
        (onChange)="onChangeFilterType($event)" optionLabel="name" optionValue="value" class="mr-2"></p-dropdown>
    </div>
    <div *ngIf="filterTypeBool" class="col-12 md:col-6 lg:col-2">
      <label *ngIf="facilityQPSLbl == 1"><b
          [ngStyle]="facilityErrorBool && facilityQPSLbl == 1 ? {'color':'red','font-size':'15px'} : {'color':'black'}">Facility</b></label>
      <label *ngIf="facilityQPSLbl == 2"><b
          [ngStyle]="facilityErrorBool && facilityQPSLbl == 2 ? {'color':'red','font-size':'15px'} : {'color':'black'}">System</b></label>
      <label *ngIf="facilityQPSLbl == 3"><b
          [ngStyle]="facilityErrorBool && facilityQPSLbl == 3 ? {'color':'red','font-size':'15px'} : {'color':'black'}">Regional</b></label>
      <p-dropdown #dd [options]="SelectListFilter" [(ngModel)]="selectFacilityPIOptions"
        (onChange)="getSelectedValue(dd)" optionLabel="Text" [filter]="true" filterBy="Text" placeholder="-- Select --"
        optionValue="Value" class="mr-2"></p-dropdown>
    </div>
     <!-- Newly Added Spoke Side -->
     <div class="col-12 md:col-6 lg:col-2" *ngIf="spokeSiteBool == true">
      <label for="FirstName"><b>Spoke Site</b></label>
      <p-dropdown [options]="spokeSiteOpions" [(ngModel)]="spokeSite" optionLabel="Text" optionValue="Value"
        class="mr-2"></p-dropdown>
    </div>
    <div class="col-12 md:col-6 lg:col-2">
      <label for="FirstName"
        [ngStyle]="reportTypeErrorBool ? {'color':'red','font-size':'15px'} : {'color':'black'}"><b>Report
          Type</b></label>
      <p-dropdown [options]="selectReportTypeOptions" [(ngModel)]="SelectedReportType" placeholder="Select Report Type"
        (onChange)="onChangeReportType($event)" optionLabel="name" optionValue="value" class="mr-2"></p-dropdown>
    </div>
    <div class="col-12 md:col-6 lg:col-2" *ngIf="monthBool">
      <label for="FirstName"><b
          [ngStyle]="monthErrorBool ? {'color':'red','font-size':'15px'} : {'color':'black'}">Month</b></label>
      <p-calendar placeholder="Month" [(ngModel)]="Month" view="month" dateFormat="MM/yy" [showIcon]="true"
        inputId="icon" [defaultDate]="Month" class="mr-2" [readonlyInput]="true"></p-calendar>
    </div>
    <div class="col-12 md:col-6 lg:col-2" *ngIf="quarterYearBool">
      <label for="FirstName"><b
          [ngStyle]="yearErrorBool ? {'color':'red','font-size':'15px'} : {'color':'black'}">Year</b></label>
      <p-calendar placeholder="Year" (onSelect)="onChangeYearQuarter(event)" [(ngModel)]="YearQuarter" view="year"
        dateFormat="yy" [showIcon]="true" inputId="icon" [defaultDate]="YearQuarter" class="mr-2" [readonlyInput]="true"></p-calendar>
    </div>
    <div class="col-12 md:col-6 lg:col-2" *ngIf="quarterBool">
      <label for="FirstName"><b
          [ngStyle]="quarterErrorBool ? {'color':'red','font-size':'15px'} : {'color':'black'}">Quarter</b></label>
      <p-dropdown [options]="selectQuarterOptions" [(ngModel)]="selectedQuarter" placeholder="Select Quarter"
        optionLabel="name" optionValue="value" class="mr-2"></p-dropdown>
    </div>
  </div>
  <div class="md:col-12 px-0">
    <!-- Search Filters SelectEnd -->
    <div class="flex justify-content-end mb-2" id="search_chart_excel_btn">
      <!-- Search and Export button start -->
      <p-button label="Search" icon="pi pi-search" (click)="getFacilityDashboardValues()"
        [loading]="improveSearchLoader == true" class="p-button-primary"></p-button>
    </div><!-- Search and Export button end -->
  </div>
  <div>
    <div class="default-OutliersReport">
    <h3 *ngIf="noRecordFoundDataBool" class="text-center">
      <b> No records found</b>
    </h3>
  </div>
    <div class="default-OutliersReport" *ngIf="isShow == true">
      <section>
        <h2><b>Facility Dashboard Outliers Report</b></h2>
        <h3><b>{{headingSummaryOportunity}}</b></h3>
        <ul>
          <li class="mb-3" *ngFor="let improvedata of improveAHAAHASFL">{{improvedata.QualityMetrics}} was at
            <b
              [style]="((improvedata?.QualityMetrics?.includes('%') || improvedata?.QualityMetrics?.includes('10')) && improvedata.commonDataR < improvedata.commonGoalsR && !improvedata?.QualityMetrics?.includes('#')) || (!(improvedata?.QualityMetrics?.includes('%') || improvedata?.QualityMetrics?.includes('10')) && improvedata.commonDataR > improvedata.commonGoalsR && !improvedata?.QualityMetrics?.includes('#')) ? 'color: red; font-weight: bold;' : ''">{{improvedata.commonData}}</b>
            <span
              *ngIf="!(improvedata.QualityMetrics.includes('#') ||improvedata.commonData?.toString().includes('%'))">
              minutes</span> <span *ngIf="improvedata.commonGoals">{{!(improvedata.commonData.includes('%')) ?
              ' (goal of less
              than ' + improvedata.commonGoals + ')': ' (goal of more than ' + improvedata.commonGoals + ')'}}</span>
          </li>
          <li class="mb-3" *ngFor="let improvedata of improveAHAAHASFL2">{{improvedata.QualityMetrics}} was at
            <b
              [style]="((improvedata?.QualityMetrics?.includes('%') || improvedata?.QualityMetrics?.includes('10')) && improvedata.commonDataR < improvedata.commonGoalsR && !improvedata?.QualityMetrics?.includes('#')) || (!(improvedata?.QualityMetrics?.includes('%') || improvedata?.QualityMetrics?.includes('10')) && improvedata.commonDataR > improvedata.commonGoalsR && !improvedata?.QualityMetrics?.includes('#')) ? 'color: red; font-weight: bold;' : ''">{{improvedata.commonData}}</b>
            <span *ngIf="!(improvedata.commonData?.toString()).includes('%')"> minutes</span> <span
              *ngIf="improvedata.commonGoals">{{!(improvedata.commonData.includes('%')) ? ' (goal of less
              than ' + improvedata.commonGoals + ')': ' (goal of more than ' + improvedata.commonGoals + ')'}}</span>
          </li>
          <li class="mb-3" *ngFor="let improvedata of activationToNeedleArray"><span
              [innerHTML]="improvedata.QualityMetrics"></span> was at
            <b
              [style]="((improvedata?.QualityMetrics?.includes('%') || improvedata?.QualityMetrics?.includes('10')) && improvedata.commonDataR < improvedata.commonGoalsR && !improvedata?.QualityMetrics?.includes('#')) || (!(improvedata?.QualityMetrics?.includes('%') || improvedata?.QualityMetrics?.includes('10')) && improvedata.commonDataR > improvedata.commonGoalsR && !improvedata?.QualityMetrics?.includes('#')) ? 'color: red; font-weight: bold;' : ''">{{improvedata.commonData}}</b>
            <span *ngIf="!(improvedata.commonData?.toString()).includes('%')"> minutes</span>
            <span
              *ngIf="improvedata.commonGoals">{{!(improvedata.commonData.includes('%')) ? ' (goal of less
              than ' + improvedata.commonGoals + ')': ' (goal of more than ' + improvedata.commonGoals + ')'}}</span>
          </li>
          <h3><b>Activation (measure of hospital activation of TS):</b></h3>
          <li class=" mb-3" *ngFor="let improvedata of improveAData"><span
              [innerHTML]="improvedata.QualityMetrics"></span> was at
            <b
              [style]="((improvedata?.QualityMetrics?.includes('%') || improvedata?.QualityMetrics?.includes('10')) && improvedata.commonDataR < improvedata.commonGoalsR && !improvedata?.QualityMetrics?.includes('#')) || (!(improvedata?.QualityMetrics?.includes('%') || improvedata?.QualityMetrics?.includes('10')) && improvedata.commonDataR > improvedata.commonGoalsR && !improvedata?.QualityMetrics?.includes('#')) ? 'color: red; font-weight: bold;' : ''">{{improvedata.commonData}}</b>
            <span *ngIf="!(improvedata.commonData?.toString()).includes('%')"> minutes</span> <span
              *ngIf="improvedata.commonGoals">{{!(improvedata.commonData.includes('%')) ? ' (goal of less
              than ' + improvedata.commonGoals + ')': ' (goal of more than ' + improvedata.commonGoals + ')'}}</span>
          </li>
          <h3><b>Notification to TS initial response (measure of TS response):</b></h3>
          <li class="mb-3" *ngFor="let improvedata of improveAAData"><span
              [innerHTML]="improvedata.QualityMetrics"></span> was at
            <b
              [style]="((improvedata?.QualityMetrics?.includes('%') || improvedata?.QualityMetrics?.includes('10')) && improvedata.commonDataR < improvedata.commonGoalsR && !improvedata?.QualityMetrics?.includes('#')) || (!(improvedata?.QualityMetrics?.includes('%') || improvedata?.QualityMetrics?.includes('10')) && improvedata.commonDataR > improvedata.commonGoalsR && !improvedata?.QualityMetrics?.includes('#')) ? 'color: red; font-weight: bold;' : ''">{{improvedata.commonData}}</b>
            <span *ngIf="!(improvedata.commonData?.toString()).includes('%')"> minutes</span> <span
              *ngIf="improvedata.commonGoals">{{!(improvedata.commonData.includes('%')) ? ' (goal of less
              than ' + improvedata.commonGoals + ')': ' (goal of more than ' + improvedata.commonGoals + ')'}}</span>
          </li>
          <h3><b>Activation to Assessment (measure of teleneurology ability to assess the patient after activation):</b>
          </h3>
          <li class="mb-3" *ngFor="let improvedata of improveNData"><span
              [innerHTML]="improvedata.QualityMetrics"></span> was at
            <b
              [style]="((improvedata?.QualityMetrics?.includes('%') || improvedata?.QualityMetrics?.includes('10')) && improvedata.commonDataR < improvedata.commonGoalsR && !improvedata?.QualityMetrics?.includes('#')) || (!(improvedata?.QualityMetrics?.includes('%') || improvedata?.QualityMetrics?.includes('10')) && improvedata.commonDataR > improvedata.commonGoalsR && !improvedata?.QualityMetrics?.includes('#')) ? 'color: red; font-weight: bold;' : ''">{{improvedata.commonData}}</b>
            <span *ngIf="!(improvedata.commonData?.toString()).includes('%')"> minutes</span> <span
              *ngIf="improvedata.commonGoals">{{!(improvedata.commonData.includes('%')) ? ' (goal of less
              than ' + improvedata.commonGoals + ')': ' (goal of more than ' + improvedata.commonGoals + ')'}}</span>
          </li>
          <h3><b>Assessment to Thrombolytic Decision<br>(measure of teams ability to obtain critical information for
              decision, and physicians decision to administer thrombolytic after all information is obtained for
              decision):</b></h3>
          <li class="mb-3" *ngFor="let improvedata of improveATData"><span
              [innerHTML]="improvedata.QualityMetrics"></span> was at
            <b
              [style]="((improvedata?.QualityMetrics?.includes('%') || improvedata?.QualityMetrics?.includes('10')) && improvedata.commonDataR < improvedata.commonGoalsR && !improvedata?.QualityMetrics?.includes('#')) || (!(improvedata?.QualityMetrics?.includes('%') || improvedata?.QualityMetrics?.includes('10')) && improvedata.commonDataR > improvedata.commonGoalsR && !improvedata?.QualityMetrics?.includes('#')) ? 'color: red; font-weight: bold;' : ''">{{improvedata.commonData}}</b>
            <span *ngIf="!(improvedata.commonData?.toString()).includes('%')"> minutes</span> <span
              *ngIf="improvedata.commonGoals">{{!(improvedata.commonData.includes('%')) ? ' (goal of less
              than ' + improvedata.commonGoals + ')': ' (goal of more than ' + improvedata.commonGoals + ')'}}</span>
          </li>
          <h3><b>Thrombolytic Decision to Administration (measure of speed of administration of thrombolytic by team
              after decision):</b></h3>
          <li class="mb-3" *ngFor="let improvedata of improveTAMHATS"><span
              [innerHTML]="improvedata.QualityMetrics"></span> was at
            <b
              [style]="((improvedata?.QualityMetrics?.includes('%') || improvedata?.QualityMetrics?.includes('10')) && improvedata.commonDataR < improvedata.commonGoalsR && !improvedata?.QualityMetrics?.includes('#')) || (!(improvedata?.QualityMetrics?.includes('%') || improvedata?.QualityMetrics?.includes('10')) && improvedata.commonDataR > improvedata.commonGoalsR && !improvedata?.QualityMetrics?.includes('#')) ? 'color: red; font-weight: bold;' : ''">{{improvedata.commonData}}</b>
            <span *ngIf="!(improvedata.commonData?.toString()).includes('%')"> minutes</span> <span
              *ngIf="improvedata.commonGoals">{{!(improvedata.commonData.includes('%')) ? ' (goal of less
              than ' + improvedata.commonGoals + ')': ' (goal of more than ' + improvedata.commonGoals + ')'}}</span>
          </li>
        </ul>
      </section>
      <section>
        <h2><b>RAPIDi Metric Outliers</b></h2>
        <ul>
          <!-- Activation -->
          <h3><b>Activation Time Interval</b></h3>
          <li class="mb-3">Activation Time Interval outliers beyond benchmark for EMS cases (goal of <b>0</b> minutes)
            was <b>{{activationTimeListQualifyCountEMS}}</b> out of <b>{{activationTotalRecords}}</b> cases
            (<b>Maximum</b>: {{activationEMSTimeCasesMaximum}}; <b>Mean</b>: {{activationEMSTimeCasesMean}} ; <b>Median</b>:
            {{activationEMSTimeCasesMedian}})
          </li>
          <li class="mb-3">Activation Time Interval outliers beyond benchmark for Triage cases (goal of <b>10</b>
            minutes)
            was <b>{{activationTimeListQualifyCountTriage}}</b> out of <b>{{activationTgTotalRecords}}</b> cases
            (<b>Maximum</b>: {{activationTriageTimeCasesMaximum}}; <b>Mean</b>: {{activationTriageTimeCasesMean}} ; <b>Median</b>:
            {{activationTriageTimeCasesMedian}})
          </li>
          <li>From the EMS cases, {{WorkFlowTypePercentage}}% were called at pre-arrival.</li>
          <!-- Assessment -->
          <h3><b>Assessment Time Interval</b></h3>
          <li class="mb-3">Assessment Time Interval outliers beyond benchmark for EMS cases (goal of <b>12</b> minutes)
            was <b>{{assessmentTimeListQualifyCountEMS}}</b> out of <b>{{assessmentTotalRecords}}</b> cases
            (<b>Maximum</b>: {{assessmentEMSTimeCasesMaximum}}; <b>Mean</b>: {{assessmentEMSTimeCasesMean}} ; <b>Median</b>:
            {{assessmentEMSTimeCasesMedian}})
          </li>
          <li class="mb-3">Assessment Time Interval outliers beyond benchmark for Inpatient cases (goal of <b>12</b>
            minutes)
            was <b>{{assessmentTimeListQualifyCountInpatient}}</b> out of <b>{{assessmentTotalInpatientRecords}}</b> cases
            (<b>Maximum</b>: {{assessmentInpatientTimeCasesMaximum}}; <b>Mean</b>: {{assessmentInpatientTimeCasesMean}} ; <b>Median</b>:
            {{assessmentInpatientTimeCasesMedian}})
          </li>
          <li class="mb-3">Assessment Time Interval outliers beyond benchmark for Triage cases (goal of <b>12</b>
            minutes)
            was <b>{{assessmentTimeListQualifyCountTriage}}</b> out of <b>{{assessmentTotalTriageRecords}}</b> cases
            (<b>Maximum</b>: {{assessmentTriageTimeCasesMaximum}}; <b>Mean</b>: {{assessmentTriageTimeCasesMean}} ; <b>Median</b>:
            {{assessmentTriageTimeCasesMedian}})
          </li>
          <li class="mb-3">Assessment Time Interval outliers beyond benchmark for ED Onset cases (goal of <b>12</b>
            minutes)
            was <b>{{assessmentTimeListQualifyCountEDOnset}}</b> out of <b>{{assessmentTotalEDOnsetRecords}}</b> cases
            (<b>Maximum</b>: {{assessmentEDOnsetTimeCasesMaximum}}; <b>Mean</b>: {{assessmentEDOnsetTimeCasesMean}} ; <b>Median</b>:
            {{assessmentEDOnsetTimeCasesMedian}})
          </li>
          <!-- THROMBOLYTIC DECISION -->
          <h3><b>Thrombolytic Decision Time Interval</b></h3>
          <li class="mb-3">Thrombolytic Decision Time Interval outliers beyond benchmark for EMS cases (goal of
            <b>10</b>
            minutes)
            was <b>{{thrombolyticDecisionTimeListQualifyCountEMS}}</b> out of
            <b>{{thrombolyticDecisionTotalRecords}}</b> cases (<b>Maximum</b>: {{thrombolyticDecisionEMSTimeCasesMaximum}};
            <b>Mean</b>: {{thrombolyticDecisionEMSTimeCasesMean}} ; <b>Median</b>: {{thrombolyticDecisionEMSTimeCasesMedian}})
          </li>
          <li class="mb-3">Thrombolytic Decision Time Interval outliers beyond benchmark for Inpatient cases (goal of
            <b>10</b>
            minutes)
            was <b>{{thrombolyticDecisionTimeListQualifyCountInpatient}}</b> out of
            <b>{{thrombolyticDecisionTotalInpatientRecords}}</b> cases (<b>Maximum</b>: {{thrombolyticDecisionInpatientTimeCasesMaximum}};
            <b>Mean</b>: {{thrombolyticDecisionInpatientTimeCasesMean}} ; <b>Median</b>: {{thrombolyticDecisionInpatientTimeCasesMedian}})
          </li>
          <li class="mb-3">Thrombolytic Decision Time Interval outliers beyond benchmark for Triage cases (goal of
            <b>10</b>
            minutes)
            was <b>{{thrombolyticDecisionTimeListQualifyCountTriage}}</b> out of
            <b>{{thrombolyticDecisionTotalTriageRecords}}</b> cases (<b>Maximum</b>: {{thrombolyticDecisionTriageTimeCasesMaximum}};
            <b>Mean</b>: {{thrombolyticDecisionTriageTimeCasesMean}} ; <b>Median</b>: {{thrombolyticDecisionTriageTimeCasesMedian}})
          </li>
          <li class="mb-3">Thrombolytic Decision Time Interval outliers beyond benchmark for ED Onset cases (goal of
            <b>10</b>
            minutes)
            was <b>{{thrombolyticDecisionTimeListQualifyCountEDOnset}}</b> out of
            <b>{{thrombolyticDecisionEDOnsetRecords}}</b> cases (<b>Maximum</b>: {{thrombolyticDecisionEDOnsetTimeCasesMaximum}};
            <b>Mean</b>: {{thrombolyticDecisionEDOnsetTimeCasesMean}} ; <b>Median</b>: {{thrombolyticDecisionEDOnsetTimeCasesMedian}})
          </li>
          <!-- THROMBOLYTIC ADMINISTRATION -->
          <h3><b>Thrombolytic Administration Time Interval</b></h3>
          <li class="mb-3">Thrombolytic Administration Time Interval outliers beyond benchmark for EMS cases (goal of
            <b>8</b>
            minutes) was <b>{{thrombolyticAdministrationTimeListQualifyCountEMS}}</b> out of
            <b>{{thrombolyticAdministrationTotalRecords}}</b> cases (<b>Maximum</b>:
            {{thrombolyticAdministrationEMSTimeCasesMaximum}}; <b>Mean</b>: {{thrombolyticAdministrationEMSTimeCasesMean}} ;
            <b>Median</b>: {{thrombolyticAdministrationEMSCasesMedian}})
          </li>
          <li class="mb-3">Thrombolytic Administration Time Interval outliers beyond benchmark for Inpatient cases
            (goal of <b>8</b>
            minutes) was <b>{{thrombolyticAdministrationTimeListQualifyCountInpatient}}</b> out of
            <b>{{thrombolyticAdministrationTotalInpatientRecords}}</b> cases (<b>Maximum</b>:
            {{thrombolyticAdministrationInpatientTimeCasesMaximum}}; <b>Mean</b>: {{thrombolyticAdministrationInpatientTimeCasesMean}} ;
            <b>Median</b>: {{thrombolyticAdministrationInpatientTimeCasesMedian}})
          </li>
          <li class="mb-3">Thrombolytic Administration Time Interval outliers beyond benchmark for Triage cases
            (goal of <b>8</b>
            minutes) was <b>{{thrombolyticAdministrationTimeListQualifyCountTriage}}</b> out of
            <b>{{thrombolyticAdministrationTotalTriageRecords}}</b> cases (<b>Maximum</b>:
            {{thrombolyticAdministrationTriageTimeCasesMaximum}}; <b>Mean</b>: {{thrombolyticAdministrationTriageTimeCasesMean}} ;
            <b>Median</b>: {{thrombolyticAdministrationTriageTimeCasesMedian}})
          </li>
          <li class="mb-3">Thrombolytic Administration Time Interval outliers beyond benchmark ED Onset cases
            (goal of <b>8</b>
            minutes) was <b>{{thrombolyticAdministrationTimeListQualifyCountEDOnset}}</b> out of
            <b>{{thrombolyticAdministrationTotalEDOnsetRecords}}</b> cases (<b>Maximum</b>:
            {{thrombolyticAdministrationEDOnsetTimeCasesMaximum}}; <b>Mean</b>: {{thrombolyticAdministrationEDOnsetTimeCasesMean}} ;
            <b>Median</b>: {{thrombolyticAdministrationEDOnsetTimeCasesMedian}})
          </li>
        </ul>
      </section>
    </div>
  </div>

  <div *ngIf="isShow == true">
    <div class="bg-default px-3 pb-0">
      <div class="flex justify-content-between align-items-center title-bg title-case">
        <div class="conten improvecontent-facility">
          <div class="btn"><a class="improve-facility"> {{selectedFilterType == 'system' ? 'System' : selectedFilterType == 'facility' ? 'Facility' : 'Regional'}} -
              {{selectedOptionText}} - {{SelectedReportType == 'quarterly' ? 'Quarterly': 'Monthly'}} Report</a></div>
        </div>
      </div>
    </div>
    <p-table #dt [value]="bodyFacilityImprovefacilityList" styleClass="p-datatable-striped p-datatable-gridlines"
      sortMode="multiple" responsiveLayout="scroll" [rowHover]="true" sortMode="multiple"
      (sortFunction)="customSort($event)" [customSort]="true" [resizableColumns]="false">
      <ng-template pTemplate="header">
        <tr>
          <th *ngFor="let headerFacilityList of headerFacilityImprovefacilityList"> {{headerFacilityList}} </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-bodyFacilityImprovefacilityList>
        <tr>
          <td *ngFor="let subBodyFacilityList of bodyFacilityImprovefacilityList"
            [style]="(subBodyFacilityList?.quality?.includes('Notification Mean') || (subBodyFacilityList?.quality?.includes('Notification Median')) 
                || (subBodyFacilityList?.quality?.includes('Notification Mean')) || (subBodyFacilityList?.quality?.includes('Notification Median'))
                || (subBodyFacilityList?.quality?.includes('Assessment')) || (subBodyFacilityList?.quality?.includes('Decision'))  ? 'color: white; background: #9f1f60;' : '')">
            {{subBodyFacilityList.quality}}</td>
          <td *ngFor="let subBodyFacilityList of bodyFacilityImprovefacilityList;" [ngStyle]="getStyle(subBodyFacilityList, 'data1')">
            {{subBodyFacilityList.data1}}</td>
          <td *ngFor="let subBodyFacilityList of bodyFacilityImprovefacilityList;" [ngStyle]="getStyle(subBodyFacilityList, 'data2')">
            {{subBodyFacilityList.data2}}</td>
          <td *ngFor="let subBodyFacilityList of bodyFacilityImprovefacilityList;" [ngStyle]="getStyle(subBodyFacilityList, 'data3')">
            {{subBodyFacilityList.data3}}</td>
          <td *ngFor="let subBodyFacilityList of bodyFacilityImprovefacilityList"  [ngStyle]="getStyle(subBodyFacilityList, 'data4')">{{subBodyFacilityList.cumlative1}}
          </td>
          <td *ngFor="let subBodyFacilityList of bodyFacilityImprovefacilityList"  [ngStyle]="getStyle(subBodyFacilityList, 'data5')">{{subBodyFacilityList.cumlative2}}
          </td>
          <td *ngFor="let subBodyFacilityList of bodyFacilityImprovefacilityList">{{subBodyFacilityList.goals3}}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <h5 *ngIf="totalFacilityComulativeDataRecord==0" class="text-center create-roles">
            <b> No records found</b>
          </h5>
        </tr>
      </ng-template>

    </p-table>
    <hr>
    <div class="grid">
      <div class="col-12 md:col-6 lg:col-6">
        <label><b>Accomplishments/Improvements:</b></label>
        <textarea pInputTextarea class="mr-4" [rows]="5" [cols]="30" class="mt-2" (input)="onTextareaChange($event,'improvements')"
          [(ngModel)]="qti_accomplishments_improvements" label="bged" name="improveFirstTA" id="improveFirstTA" [readonly]="roleForFacility || isAccessRead"
          cols="30" rows="10" style="resize: vertical; min-height:100px;">{{qti_accomplishments_improvements}}</textarea>
      </div>
      <div class="col-12 md:col-6 lg:col-6">
        <label><b>Opportunities and PI Projects:</b></label>
        <textarea pInputTextarea [rows]="5" [cols]="30" class="mt-2" [(ngModel)]="qti_opportunities_pi_projects" (input)="onTextareaChange($event,'projects')"
          aria-label="jrtyj" name="improveSecondTA" id="improveSecondTA" cols="30" rows="10" [readonly]="roleForFacility || isAccessRead"
          style="resize: vertical; min-height:100px;">{{qti_opportunities_pi_projects}}</textarea>
      </div>
  </div>

    <p-accordion>
      <p-accordionTab header="{{selectedFilterType == 'system' ? 'System' : selectedFilterType == 'facility' ? 'Facility' : 'Regional'}} -
      {{selectedOptionText}} - {{SelectedReportType == 'quarterly' ? 'Quarterly': 'Monthly'}} Charts" [selected]="false">
        <div class="grid" *ngIf="!chartFoundBool">
          <div class="md:col-1 chart-popup bg-default px-3 pb-3"></div>
          <div class="md:col-10 chart-popup bg-default px-3 pb-3" id="htmlData1" #htmlData1>
              <span class="piechart-header">
                <p class="pie-text">Stroke Alert Chart, {{minDateSelectedStrokeAlert}} - {{maxDateSelectedStrokeAlert}}</p>
            </span>
            <span class="piechart-header">
              <p class="text-center pie-text">Total Cases - {{TotaAllSelectedDateStrokeAlert}}</p>
            </span>
              <kendo-chart title="" class="kendoChart" *ngIf="!selectedDateStrokeAlertBool">
                <kendo-chart-legend position="bottom" [labels]="{ color: '#000000',font: 'bold 18px Arial, sans-serif'}"></kendo-chart-legend>
                <kendo-chart-series>
                  <kendo-chart-series-item type="pie" [data]="pieDataSelectedDateStrokeAlert" field="value" categoryField="category"
                  colorField="colorField" [labels]="{ visible: true, content: labelContent, visual: visualContent, color: '#000000', font: 'bold 18px Arial, sans-serif' }">
                  </kendo-chart-series-item>
                </kendo-chart-series>
              </kendo-chart>
              <h1 *ngIf="selectedDateStrokeAlertBool" class="text-center">No Record Found</h1>
          </div>
          <div class="md:col-1 chart-popup bg-default px-3 pb-3"></div>
          <div class="md:col-1 chart-popup bg-default px-3 pb-3"></div>
          <div class="md:col-10 chart-popup bg-default px-3 pb-3" id="htmlData2" #htmlData2>
              <span class="piechart-header">
                <p class="pie-text">Volumetric Chart, {{minDateSelectedVolumetric}} - {{maxDateSelectedVolumetric}}</p>
            </span>
            <span class="piechart-header">
              <p class="text-center pie-text">Total Cases - {{TotaAllCasesSelectedVolimatric}}</p>
            </span>
              <kendo-chart title="" class="kendoChart" *ngIf="!selectedDateVolumetricBool">
                <kendo-chart-legend position="bottom"  [labels]="{ color: '#000000',font: 'bold 18px Arial, sans-serif'}"></kendo-chart-legend>
                <kendo-chart-series>
                  <kendo-chart-series-item type="pie" [data]="pieDataSelectedVolimatric" field="value" categoryField="category"
                  colorField="colorField" [labels]="{ visible: true, content: labelContent, visual: visualContent, color: '#000000',font: 'bold 18px Arial, sans-serif'}">
                  </kendo-chart-series-item>
                </kendo-chart-series>
              </kendo-chart>
              <h1 *ngIf="selectedDateVolumetricBool" class="text-center">No Record Found</h1>
          </div>
          <div class="md:col-1 chart-popup bg-default px-3 pb-3"></div>
          <div class="md:col-1 chart-popup bg-default px-3 pb-3"></div>
          <div class="md:col-10 chart-popup bg-default px-3 pb-3" id="htmlData3" #htmlData3>
              <span class="piechart-header">
                <p class="pie-text">Volumetric Chart, {{minDateFirstMonthVolumetric}} - {{maxDateFirstMonthVolumetric}}</p>
            </span>
            <span class="piechart-header">
              <p class="text-center pie-text">Total Cases - {{TotaAllFirstMonthDateVolumetric}}</p>
            </span>
              <kendo-chart title="" class="kendoChart" *ngIf="!firstMonthDateVolumetricBool">
                <kendo-chart-legend position="bottom" [labels]="{ color: '#000000',font: 'bold 18px Arial, sans-serif'}" ></kendo-chart-legend>
                <kendo-chart-series>
                  <kendo-chart-series-item type="pie" [data]="firstMonthDateVolumetric" field="value" categoryField="category"
                  colorField="colorField" [labels]="{ visible: true, content: labelContent, visual: visualContent, color: '#000000',font: 'bold 18px Arial, sans-serif'}">
                  </kendo-chart-series-item>
                </kendo-chart-series>
              </kendo-chart>
              <h1 *ngIf="firstMonthDateVolumetricBool" class="text-center">No Record Found</h1>
          </div>
          <div class="md:col-1 chart-popup bg-default px-3 pb-3"></div>
          <div class="md:col-1 chart-popup bg-default px-3 pb-3"></div>
          <div class="md:col-10 chart-popup bg-default px-3 pb-3" id="htmlData4" #htmlData4>
            <kendo-chart class="QMSALLCHARTS" [seriesColors]="seriesColors">
              <kendo-chart-title text="Door to Notification Mean and Median (Min:Sec) (Goal: 0 Minute for EMS, &le; 10 Minutes for Triage) " color="black"
                font="bold 20px Arial, sans-serif" [align]="titleAlignment.align" [margin]="{ bottom: 50 }">
              </kendo-chart-title>

              <kendo-chart-legend position="bottom" [labels]="{ color: '#000000',font: 'bold 18px Arial, sans-serif'}">
              </kendo-chart-legend>

              <kendo-chart-category-axis>
                <kendo-chart-category-axis-item [categories]="doortostartcatgory">
                  <kendo-chart-category-axis-item-labels font="bold 14px Arial, sans-serif" color="black"
                    rotation="auto">
                  </kendo-chart-category-axis-item-labels>
                </kendo-chart-category-axis-item>
              </kendo-chart-category-axis>

              <kendo-chart-value-axis>
                <kendo-chart-value-axis-item [min]="doortostartMinDate" [max]="doortostartMaxDate + 80000">
                  <kendo-chart-value-axis-item-labels [content]="formatYAxisLabel" font="bold 14px Arial, sans-serif"
                    color="#000000">
                  </kendo-chart-value-axis-item-labels>
                </kendo-chart-value-axis-item>
              </kendo-chart-value-axis>

              <kendo-chart-series>
                <kendo-chart-series-item [data]="doortostartmeancal" [spacing]="0.25" [gap]="1" type="line"
                  smooth="true" [color]="series.color" [style]="style" name="Mean" [labels]="seriesLabels">
                  <kendo-chart-series-item-labels [background]="'transparent'" [position]="'above'"
                    [margin]="{ bottom: calculateLengthForMarginLabel() }" [content]="doortostartMeanChartContent"
                    [color]="series.color" [font]="screenWidth < 1300 ? seriesWidth.font : series.font">
                  </kendo-chart-series-item-labels>
                </kendo-chart-series-item>
                <kendo-chart-series-item [data]="doortostartmediancal" [spacing]="0.25" [gap]="1" type="line"
                  smooth="true" [color]="seriesMedian.color" [style]="style" name="Median" [labels]="seriesLabels">
                  <kendo-chart-series-item-labels [background]="'transparent'" [position]="'above'"
                    [content]="doortostartMedianChartContent" [color]="seriesMedian.color"
                    [font]="screenWidth < 1300 ? seriesWidth.font : series.font">
                  </kendo-chart-series-item-labels>
                </kendo-chart-series-item>
              </kendo-chart-series>
            </kendo-chart>
          </div>
          <div class="md:col-1 chart-popup bg-default px-3 pb-3"></div>
          <div class="md:col-1 chart-popup bg-default px-3 pb-3"></div>
          <div class="md:col-10 chart-popup bg-default px-3 pb-3" id="htmlData5" #htmlData5>

            <kendo-chart class="QMSALLCHARTS" [seriesColors]="seriesColors">
              <kendo-chart-title text="% 10 Min or Less Activation EMS & Triage" color="black"
                font="bold 20px Arial, sans-serif" [align]="titleAlignment.align" [margin]="{ bottom: 50 }">
              </kendo-chart-title>

              <kendo-chart-legend position="bottom" [labels]="{ color: '#000000',font: 'bold 16px Arial, sans-serif'}">
              </kendo-chart-legend>

              <kendo-chart-category-axis>
                <kendo-chart-category-axis-item [categories]="activationemscatgory">
                  <kendo-chart-category-axis-item-labels font="bold 14px Arial, sans-serif" color="black"
                    rotation="auto">
                  </kendo-chart-category-axis-item-labels>
                </kendo-chart-category-axis-item>
              </kendo-chart-category-axis>

              <kendo-chart-value-axis>
                <kendo-chart-value-axis-item [min]="0" [labels]="valueAxisLabels">
                </kendo-chart-value-axis-item>
              </kendo-chart-value-axis>

              <kendo-chart-series>
                <kendo-chart-series-item name="EMS" [data]="activationemsmeancal" [spacing]="0.25" [gap]="1"
                  [labels]="seriesLabels" [color]="series.color" smooth="true">
                  <kendo-chart-series-item-labels [color]="series.colorLabel" [font]="series.font">
                  </kendo-chart-series-item-labels>
                </kendo-chart-series-item>
                <kendo-chart-series-item name="Triage/PV" [data]="activationpvmeancal" [spacing]="0.25" [gap]="1"
                  [labels]="seriesLabels" [color]="seriesMedian.color" smooth="true">
                  <kendo-chart-series-item-labels [color]="seriesMedian.colorLabel" [font]="series.font">
                  </kendo-chart-series-item-labels>
                </kendo-chart-series-item>
              </kendo-chart-series>
            </kendo-chart>
          </div>
          <div class="md:col-1 chart-popup bg-default px-3 pb-3"></div>
          <div class="md:col-1 chart-popup bg-default px-3 pb-3"></div>
          <div class="md:col-10 chart-popup bg-default px-3 pb-3" id="htmlData6" #htmlData6>

            <kendo-chart class="QMSALLCHARTS" [seriesColors]="seriesColors">
              <kendo-chart-title text="Activation to Assessment Mean and Median (Min:Sec) (Goal:  &le; 12 Minutes)" color="black"
                font="bold 20px Arial, sans-serif" [align]="titleAlignment.align" [margin]="{ bottom: 50 }">
              </kendo-chart-title>

              <kendo-chart-legend position="bottom" [labels]="{ color: '#000000',font: 'bold 16px Arial, sans-serif' }">
              </kendo-chart-legend>

              <kendo-chart-category-axis>
                <kendo-chart-category-axis-item [categories]="ActivationtoAssessmentcatgory">
                  <kendo-chart-category-axis-item-labels font="bold 14px Arial, sans-serif" color="black"
                    rotation="auto">
                  </kendo-chart-category-axis-item-labels>
                </kendo-chart-category-axis-item>
              </kendo-chart-category-axis>

              <kendo-chart-value-axis>
                <kendo-chart-value-axis-item [min]="ActivationtoAssessmentMinDate" [max]="ActivationtoAssessmentMaxDate + 80000">
                  <kendo-chart-value-axis-item-labels [content]="formatYAxisLabel" font="bold 14px Arial, sans-serif"
                    color="#000000">
                  </kendo-chart-value-axis-item-labels>
                </kendo-chart-value-axis-item>
              </kendo-chart-value-axis>

              <kendo-chart-series>
                <kendo-chart-series-item [data]="ActivationtoAssessmentmeancal" [spacing]="0.25" [gap]="1" type="line"
                  smooth="true" [color]="series.color" [style]="style" name="Mean" [labels]="seriesLabels">
                  <kendo-chart-series-item-labels [background]="'transparent'" [position]="'above'"
                    [margin]="{ bottom: calculateLengthForMarginLabel() }"
                    [content]="ActivationtoAssessmentMeanChartContent" [color]="series.color"
                    [font]="screenWidth < 1300 ? seriesWidth.font : series.font">
                  </kendo-chart-series-item-labels>
                </kendo-chart-series-item>
                <kendo-chart-series-item [data]="ActivationtoAssessmentmediancal" [spacing]="0.25" [gap]="1" type="line"
                  smooth="true" [color]="seriesMedian.color" [style]="style" name="Median" [labels]="seriesLabels">
                  <kendo-chart-series-item-labels [background]="'transparent'" [position]="'above'"
                    [content]="ActivationtoAssessmentMedianChartContent" [color]="seriesMedian.color"
                    [font]="screenWidth < 1300 ? seriesWidth.font : series.font">
                  </kendo-chart-series-item-labels>
                </kendo-chart-series-item>
              </kendo-chart-series>
            </kendo-chart>
          </div>
          <div class="md:col-1 chart-popup bg-default px-3 pb-3"></div>
          <div class="md:col-1 chart-popup bg-default px-3 pb-3"></div>
          <div class="md:col-10 chart-popup bg-default px-3 pb-3" id="htmlData7" #htmlData7>

            <kendo-chart class="QMSALLCHARTS" [seriesColors]="seriesColors">
              <kendo-chart-title text="TS Notification to Initial Response Mean and Median (Min:Sec)"
                color="black" font="bold 20px Arial, sans-serif" [align]="titleAlignment.align"
                [margin]="{ bottom: 50 }">
              </kendo-chart-title>

              <kendo-chart-legend position="bottom" [labels]="{ color: '#000000',font: 'bold 16px Arial, sans-serif' }">
              </kendo-chart-legend>

              <kendo-chart-category-axis>
                <kendo-chart-category-axis-item [categories]="starttoresponsecatgory">
                  <kendo-chart-category-axis-item-labels font="bold 14px Arial, sans-serif" color="black"
                    rotation="auto">
                  </kendo-chart-category-axis-item-labels>
                </kendo-chart-category-axis-item>
              </kendo-chart-category-axis>

              <kendo-chart-value-axis>
                <kendo-chart-value-axis-item [min]="starttoresponseMinDate" [max]="starttoresponseMaxDate + 80000">
                  <kendo-chart-value-axis-item-labels [content]="formatYAxisLabel" font="bold 14px Arial, sans-serif"
                    color="#000000">
                  </kendo-chart-value-axis-item-labels>
                </kendo-chart-value-axis-item>
              </kendo-chart-value-axis>

              <kendo-chart-series>
                <kendo-chart-series-item [data]="starttoresponsemeancal" [spacing]="0.25" [gap]="1" type="line"
                  smooth="true" [color]="series.color" [style]="style" name="Mean" [labels]="seriesLabels">
                  <kendo-chart-series-item-labels [background]="'transparent'" [position]="'above'"
                    [margin]="{ bottom: calculateLengthForMarginLabel() }"
                    [content]="TS_Notification_to_Initial_ResponseMeanChartContent" [color]="series.color"
                    [font]="screenWidth < 1300 ? seriesWidth.font : series.font">
                  </kendo-chart-series-item-labels>
                </kendo-chart-series-item>
                <kendo-chart-series-item [data]="starttoresponsemediancal" [spacing]="0.25" [gap]="1" type="line"
                  smooth="true" [color]="seriesMedian.color" [style]="style" name="Median" [labels]="seriesLabels">
                  <kendo-chart-series-item-labels [background]="'transparent'" [position]="'above'"
                    [content]="TS_Notification_to_Initial_ResponseMedianChartContent" [color]="seriesMedian.color"
                    [font]="screenWidth < 1300 ? seriesWidth.font : series.font">
                  </kendo-chart-series-item-labels>
                </kendo-chart-series-item>
              </kendo-chart-series>
            </kendo-chart>
          </div>
          <div class="md:col-1 chart-popup bg-default px-3 pb-3"></div>
          <div class="md:col-1 chart-popup bg-default px-3 pb-3"></div>
          <div class="md:col-10 chart-popup bg-default px-3 pb-3" id="htmlData8" #htmlData8>

            <kendo-chart class="QMSALLCHARTS" [seriesColors]="seriesColors">
              <kendo-chart-title text="Assessment To Thrombolytic Decision Making Mean and Median (Min:Sec) (Goal:  &le; 10 Minutes)"
                color="black" font="bold 20px Arial, sans-serif" [align]="titleAlignment.align"
                [margin]="{ bottom: 50 }">
              </kendo-chart-title>

              <kendo-chart-legend position="bottom" [labels]="{ color: '#000000',font: 'bold 16px Arial, sans-serif' }">
              </kendo-chart-legend>

              <kendo-chart-category-axis>
                <kendo-chart-category-axis-item [categories]="AssessmenttoThrombolyticcatgory">
                  <kendo-chart-category-axis-item-labels font="bold 14px Arial, sans-serif" color="black"
                    rotation="auto">
                  </kendo-chart-category-axis-item-labels>
                </kendo-chart-category-axis-item>
              </kendo-chart-category-axis>

              <kendo-chart-value-axis>
                <kendo-chart-value-axis-item [min]="AssessmenttoThrombolyticMinDate" [max]="AssessmenttoThrombolyticMaxDate + 80000">
                  <kendo-chart-value-axis-item-labels [content]="formatYAxisLabel" font="bold 14px Arial, sans-serif"
                    color="#000000">
                  </kendo-chart-value-axis-item-labels>
                </kendo-chart-value-axis-item>
              </kendo-chart-value-axis>

              <kendo-chart-series>
                <kendo-chart-series-item [data]="AssessmenttoThrombolyticmeancal" [spacing]="0.25" [gap]="1" type="line"
                  smooth="true" [color]="series.color" [style]="style" name="Mean" [labels]="seriesLabels">
                  <kendo-chart-series-item-labels [background]="'transparent'" [position]="'above'"
                    [margin]="{ bottom: calculateLengthForMarginLabel() }"
                    [content]="Assessment_to_Thrombolytic_DecisionMeanChartContent" [color]="series.color"
                    [font]="screenWidth < 1300 ? seriesWidth.font : series.font">
                  </kendo-chart-series-item-labels>
                </kendo-chart-series-item>
                <kendo-chart-series-item [data]="AssessmenttoThrombolyticmediancal" [spacing]="0.25" [gap]="1"
                  type="line" smooth="true" [color]="seriesMedian.color" [style]="style" name="Median"
                  [labels]="seriesLabels">
                  <kendo-chart-series-item-labels [background]="'transparent'" [position]="'above'"
                    [content]="Assessment_to_Thrombolytic_DecisionMedianChartContent" [color]="seriesMedian.color"
                    [font]="screenWidth < 1300 ? seriesWidth.font : series.font">
                  </kendo-chart-series-item-labels>
                </kendo-chart-series-item>
              </kendo-chart-series>
            </kendo-chart>
          </div>
          <div class="md:col-1 chart-popup bg-default px-3 pb-3"></div>
          <div class="md:col-1 chart-popup bg-default px-3 pb-3"></div>
          <div class="md:col-10 chart-popup bg-default px-3 pb-3" id="htmlData9" #htmlData9>

            <kendo-chart class="QMSALLCHARTS" [seriesColors]="seriesColors">
              <kendo-chart-title
                text="Thrombolytic Medical Decision to Thrombolytic Administration Mean and Median (Min:Sec) (Goal: &le; 8 Minutes)"
                color="black" font="bold 20px Arial, sans-serif" [align]="titleAlignment.align"
                [margin]="{ bottom: 50 }">
              </kendo-chart-title>

              <kendo-chart-legend position="bottom" [labels]="{ color: '#000000',font: 'bold 16px Arial, sans-serif'}">
              </kendo-chart-legend>

              <kendo-chart-category-axis>
                <kendo-chart-category-axis-item [categories]="ThrombolytictoThrombolyticadministrationcatgory">
                  <kendo-chart-category-axis-item-labels font="bold 14px Arial, sans-serif" color="black"
                    rotation="auto">
                  </kendo-chart-category-axis-item-labels>
                </kendo-chart-category-axis-item>
              </kendo-chart-category-axis>

              <kendo-chart-value-axis>
                <kendo-chart-value-axis-item [min]="ThrombolytictoThrombolyticMinDate" [max]="ThrombolytictoThrombolyticMaxDate + 80000">
                  <kendo-chart-value-axis-item-labels [content]="formatYAxisLabel" font="bold 14px Arial, sans-serif"
                    color="#000000">
                  </kendo-chart-value-axis-item-labels>
                </kendo-chart-value-axis-item>
              </kendo-chart-value-axis>

              <kendo-chart-series>
                <kendo-chart-series-item [data]="ThrombolytictoThrombolyticadministrationmeancal" [spacing]="0.25"
                  [gap]="1" type="line" smooth="true" [color]="series.color" [style]="style" name="Mean"
                  [labels]="seriesLabels">
                  <kendo-chart-series-item-labels [background]="'transparent'" [position]="'above'"
                    [margin]="{ bottom: calculateLengthForMarginLabel() }"
                    [content]="Thrombolytic_Decision_Making_to_AdminMeanChartContent" [color]="series.color"
                    [font]="screenWidth < 1300 ? seriesWidth.font : series.font">
                  </kendo-chart-series-item-labels>
                </kendo-chart-series-item>
                <kendo-chart-series-item [data]="ThrombolytictoThrombolyticadministrationmediancal" [spacing]="0.25"
                  [gap]="1" type="line" smooth="true" [color]="seriesMedian.color" [style]="style" name="Median"
                  [labels]="seriesLabels">
                  <kendo-chart-series-item-labels [background]="'transparent'" [position]="'above'"
                    [content]="Thrombolytic_Decision_Making_to_AdminMedianChartContent" [color]="seriesMedian.color"
                    [font]="screenWidth < 1300 ? seriesWidth.font : series.font">
                  </kendo-chart-series-item-labels>
                </kendo-chart-series-item>
              </kendo-chart-series>
            </kendo-chart>
          </div>
          <div class="md:col-1 chart-popup bg-default px-3 pb-3"></div>
          <div class="md:col-1 chart-popup bg-default px-3 pb-3"></div>
          <div class="md:col-10 chart-popup bg-default px-3 pb-3" id="htmlData10" #htmlData10>

            
            <kendo-chart class="QMSALLCHARTS" [seriesColors]="seriesColors">
              <kendo-chart-title text="DTN equal to or less than 30 minutes, 45 minutes and 60 minutes (%)"
                color="black" font="bold 20px Arial, sans-serif" [align]="titleAlignment.align"
                [margin]="{ bottom: 50 }">
              </kendo-chart-title>

              <kendo-chart-legend position="bottom" [labels]="{ color: '#000000',font: 'bold 16px Arial, sans-serif' }">
              </kendo-chart-legend>

              <kendo-chart-category-axis>
                <kendo-chart-category-axis-item [categories]="DTN30percentcatgory">
                  <kendo-chart-category-axis-item-labels font="bold 14px Arial, sans-serif" color="black"
                    rotation="auto">
                  </kendo-chart-category-axis-item-labels>
                </kendo-chart-category-axis-item>
              </kendo-chart-category-axis>

              <kendo-chart-value-axis>
                <kendo-chart-value-axis-item [min]="0" [labels]="valueAxisLabels">
                </kendo-chart-value-axis-item>
              </kendo-chart-value-axis>

              <kendo-chart-series>
                <kendo-chart-series-item name="(30)Min" [data]="DTN30percentmeancal" [spacing]="0.25" [gap]="1"
                  [labels]="seriesLabels" smooth="true">
                  <kendo-chart-series-item-labels [background]="'transparent'" [color]="series.colorLabel"
                    [font]="screenWidth < 1300 ? seriesWidth.font : series.font">
                  </kendo-chart-series-item-labels>
                </kendo-chart-series-item>
                <kendo-chart-series-item name="(45)Min" [data]="DTN45percentmeancal" [spacing]="0.25" [gap]="1"
                  [labels]="seriesLabels" smooth="true">
                  <kendo-chart-series-item-labels [background]="'transparent'" [margin]="{ bottom: 22 }"
                    [color]="seriesMedian.colorLabel" [font]="screenWidth < 1300 ? seriesWidth.font : series.font">
                  </kendo-chart-series-item-labels>
                </kendo-chart-series-item>
                <kendo-chart-series-item name="(60)Min" [data]="DTN60percentmeancal" [spacing]="0.25" [gap]="1"
                  [labels]="seriesLabels" smooth="true">
                  <kendo-chart-series-item-labels [background]="'transparent'" [margin]="{ bottom: 40 }"
                    [color]="seriesdtn60.colorLabel" [font]="screenWidth < 1300 ? seriesWidth.font : series.font">
                  </kendo-chart-series-item-labels>
                </kendo-chart-series-item>
              </kendo-chart-series>
            </kendo-chart>
          </div>
          <div class="md:col-1 chart-popup bg-default px-3 pb-3"></div>
          <div class="md:col-1 chart-popup bg-default px-3 pb-3"></div>
          <div class="md:col-10 chart-popup bg-default px-3 pb-3" id="htmlData11" #htmlData11>

            <kendo-chart class="QMSALLCHARTS" [seriesColors]="seriesColors">
              <kendo-chart-title text="Number of Thrombolytic Administered" color="black"
                font="bold 20px Arial, sans-serif" [align]="titleAlignment.align" [margin]="{ bottom: 50 }">
              </kendo-chart-title>

              <kendo-chart-legend position="bottom" [labels]="{ color: '#000000',font: 'bold 16px Arial, sans-serif' }">
              </kendo-chart-legend>

              <kendo-chart-category-axis>
                <kendo-chart-category-axis-item [categories]="alteplaseadmincatgory">
                  <kendo-chart-category-axis-item-labels font="bold 14px Arial, sans-serif" color="black"
                    rotation="auto">
                  </kendo-chart-category-axis-item-labels>
                </kendo-chart-category-axis-item>
              </kendo-chart-category-axis>

              <kendo-chart-value-axis>
                <kendo-chart-value-axis-item [min]="0" [labels]="valueAxisLabels">
                </kendo-chart-value-axis-item>
              </kendo-chart-value-axis>

              <kendo-chart-series>
                <kendo-chart-series-item [data]="alteplaseadminmeancal" [spacing]="0.25" [gap]="1"
                  name="Thrombolytic Administered" [color]="series.color" smooth="true" [labels]="seriesLabels">
                  <kendo-chart-series-item-labels [color]="series.colorLabel" [font]="series.font">
                  </kendo-chart-series-item-labels>
                </kendo-chart-series-item>
              </kendo-chart-series>
            </kendo-chart>
          </div>
          <div class="md:col-1 chart-popup bg-default px-3 pb-3"></div>
          <div class="md:col-1 chart-popup bg-default px-3 pb-3"></div>
          <div class="md:col-10 chart-popup bg-default px-3 pb-3" id="htmlData12" #htmlData12>

            <kendo-chart class="QMSALLCHARTS" [seriesColors]="seriesColors">
              <kendo-chart-title text="Door To Needle Mean and Median (Min:Sec) (Goal: &le; 45 Minutes)" color="black"
                font="bold 20px Arial, sans-serif" [align]="titleAlignment.align" [margin]="{ bottom: 50 }">
              </kendo-chart-title>

              <kendo-chart-legend position="bottom" [labels]="{ color: '#000000',font: 'bold 16px Arial, sans-serif' }">
              </kendo-chart-legend>

              <kendo-chart-category-axis>
                <kendo-chart-category-axis-item [categories]="doortoneedlecatgory">
                  <kendo-chart-category-axis-item-labels font="bold 14px Arial, sans-serif" color="black"
                    rotation="auto">
                  </kendo-chart-category-axis-item-labels>
                </kendo-chart-category-axis-item>
              </kendo-chart-category-axis>

              <kendo-chart-value-axis>
                <kendo-chart-value-axis-item [min]="doortoneedleMinDate" [max]="doortoneedleMaxDate + 80000">
                  <kendo-chart-value-axis-item-labels [content]="formatYAxisLabel" font="bold 14px Arial, sans-serif"
                    color="#000000">
                  </kendo-chart-value-axis-item-labels>
                </kendo-chart-value-axis-item>
              </kendo-chart-value-axis>

              <kendo-chart-series>
                <kendo-chart-series-item [data]="doortoneedlemeancal" [spacing]="0.25" [gap]="1" type="line"
                  smooth="true" [color]="series.color" [style]="style" name="Mean" [labels]="seriesLabels">
                  <kendo-chart-series-item-labels [background]="'transparent'" [position]="'above'"
                    [margin]="{ bottom: calculateLengthForMarginLabel() }" [content]="Door_to_NeedleMeanChartContent"
                    [color]="series.color" [font]="screenWidth < 1300 ? seriesWidth.font : series.font">
                  </kendo-chart-series-item-labels>
                </kendo-chart-series-item>
                <kendo-chart-series-item [data]="doortoneedlemediancal" [spacing]="0.25" [gap]="1" type="line"
                  smooth="true" [color]="seriesMedian.color" [style]="style" name="Median" [labels]="seriesLabels">
                  <kendo-chart-series-item-labels [background]="'transparent'" [position]="'above'"
                    [content]="Door_to_NeedleMedianChartContent" [color]="seriesMedian.color"
                    [font]="screenWidth < 1300 ? seriesWidth.font : series.font">
                  </kendo-chart-series-item-labels>
                </kendo-chart-series-item>
              </kendo-chart-series>
            </kendo-chart>
            
          </div>
          <div class="md:col-1 chart-popup bg-default px-3 pb-3"></div>
          <div class="md:col-1 chart-popup bg-default px-3 pb-3"></div>
          <div class="md:col-10 chart-popup bg-default px-3 pb-3" id="htmlData13" #htmlDat13>


            <kendo-chart class="QMSALLCHARTS" [seriesColors]="seriesColors">
              <kendo-chart-title text="Activation To Needle Mean and Median (Min:Sec) (Goal:  &le; 30 Minutes)" color="black"
                font="bold 20px Arial, sans-serif" [align]="titleAlignment.align" [margin]="{ bottom: 50 }">
              </kendo-chart-title>

              <kendo-chart-legend position="bottom" [labels]="{ color: '#000000',font: 'bold 16px Arial, sans-serif' }">
              </kendo-chart-legend>

              <kendo-chart-category-axis>
                <kendo-chart-category-axis-item [categories]="activitationtoneedlecatgory">
                  <kendo-chart-category-axis-item-labels font="bold 14px Arial, sans-serif" color="black"
                    rotation="auto">
                  </kendo-chart-category-axis-item-labels>
                </kendo-chart-category-axis-item>
              </kendo-chart-category-axis>

              <kendo-chart-value-axis>
                <kendo-chart-value-axis-item [min]="activitationtoneedleMinDate" [max]="activitationtoneedleMaxDate + 80000">
                  <kendo-chart-value-axis-item-labels [content]="formatYAxisLabel" font="bold 14px Arial, sans-serif"
                    color="#000000">
                  </kendo-chart-value-axis-item-labels>
                </kendo-chart-value-axis-item>
              </kendo-chart-value-axis>

              <kendo-chart-series>
                <kendo-chart-series-item [data]="activitationtoneedlemeancal" [spacing]="0.25" [gap]="1" type="line"
                  smooth="true" [color]="series.color" [style]="style" name="Mean" [labels]="seriesLabels">
                  <kendo-chart-series-item-labels [background]="'transparent'" [position]="'above'"
                    [margin]="{ bottom: calculateLengthForMarginLabel() }"
                    [content]="Activation_to_NeedleMeanChartContent" [color]="series.color"
                    [font]="screenWidth < 1300 ? seriesWidth.font : series.font">
                  </kendo-chart-series-item-labels>
                </kendo-chart-series-item>
                <kendo-chart-series-item [data]="activitationtoneedlemediancal" [spacing]="0.25" [gap]="1" type="line"
                  smooth="true" [color]="seriesMedian.color" [style]="style" name="Median" [labels]="seriesLabels">
                  <kendo-chart-series-item-labels [background]="'transparent'" [position]="'above'"
                    [content]="Activation_to_NeedleMedianChartContent" [color]="seriesMedian.color"
                    [font]="screenWidth < 1300 ? seriesWidth.font : series.font">
                  </kendo-chart-series-item-labels>
                </kendo-chart-series-item>
              </kendo-chart-series>
            </kendo-chart>
          </div>
          <div class="md:col-1 chart-popup bg-default px-3 pb-3"></div>
        </div>
        <div class="grid" *ngIf="chartFoundBool">
          <h4 class="text-center w-full"><b> No Data Available For Graphs </b></h4>
        </div>
      </p-accordionTab>
    </p-accordion>

    <div class="col-12 default-footerbtn">
        <p-button *ngIf="isAccessReadWrite && !roleForFacility" (click)="GetEmailImproveFacility('btn');"
        class="ml-2 p-button-primary btn-padding-custom footerbtn-paddingbtn" type="button" label="Shared Report History"
        [ngStyle]="sharedReportLoader ? {'pointer-events': 'none'} : {'pointer-events': 'all'}"
        [loading]="sharedReportLoader"></p-button>
        <p-button *ngIf="isAccessReadWrite && !roleForFacility"  class="ml-2 p-button-primary btn-padding-custom footerbtn-paddingbtn"
        (click)="CheckPostImproveData('PostImproveData')" [loading]="improveSaveLoader" type="button" [ngStyle]="isChangeTextBox ? {'pointer-events': 'none'} : {'pointer-events': 'all'}" 
        [disabled]="isChangeTextBox" label="Save">
      </p-button>
        <p-button class="ml-2 p-button-primary btn-padding-custom footerbtn-paddingbtn" type="button"
        (click)="CheckPostImproveData('PostImproveData');generateTemplate()" ngDefaultControl
        label="{{GenerateMonthlyReportText}}" [loading]="generateTemplateLoader"></p-button>
      </div>
  </div>
</div>



<p-dialog header="{{selectedFilterType == 'system' ? 'System' : selectedFilterType == 'facility' ? 'Facility' : 'Regional'}} -
{{selectedOptionText}} - {{SelectedReportType == 'quarterly' ? 'Quarterly': 'Monthly'}} Report" [draggable]="false" [modal]="true" [(visible)]="generateTemplatebool"
  [breakpoints]="{'960px': '75vw'}" [style]="{width: '70vw', height:'70vw'}">
  <div class="fixed transform z-2" *ngIf="showProgressSpinner">
    <app-custom-spinner></app-custom-spinner>
  </div>
  <ckeditor id="editor" name="editor" #editor [(ngModel)]="finalTemplateData" debounce="500" [editor]="editorr"></ckeditor>

  <ng-template pTemplate="footer">
    <div class="formgrid flex m-2">
      <div class="col-12 md:col-3 text-left mt-5">
        <button pButton type="button" (click)="closeTemplate()" class=" btn-UnCancelCase">
          <i class="pi pi-times"></i>&nbsp; <b>Cancel</b> </button>
      </div>
      <div class="col-12 md:col-9 text-right mt-5">

        <p-button *ngIf="isAccessReadWrite && !roleForFacility" (click)="GetFacilityContact(event)" class="ml-2 p-button-primary btn-padding-custom" type="button"
          label="Share" [loading]="sharebtnLoader"></p-button>

        <p-button class="ml-2 p-button-primary btn-padding-custom" type="button" [label]="roleForFacility ? 'Generate PDF' : 'Generate PDF + Word'"
          (click)="DataTransfer('Export Pdf')"></p-button>
      </div>
    </div>
  </ng-template>
</p-dialog>

<!-- Click Share btn to show dialog to send email -->
<p-dialog header="{{selectedFilterType == 'system' ? 'System' : selectedFilterType == 'facility' ? 'Facility' : 'Regional'}} -
{{selectedOptionText}} - {{SelectedReportType == 'quarterly' ? 'Quarterly': 'Monthly'}} Report" [(visible)]="displayModal" [(visible)]="displayModal"
  [modal]="true" [draggable]="false" [resizable]="false">
  <p-toast position="top-right" key="emailErr"></p-toast>
  <p-table [value]="shareImprove" [scrollable]="true" scrollHeight="400px" [resizableColumns]="true"
    columnResizeMode="expand" styleClass="p-datatable-gridlines">
    <ng-template pTemplate="header" let-shareImprove>
      <tr>
        <th style="min-width:50px">
          <p-checkbox [(ngModel)]="masterSelected" class="ml-1" name="list_name" value="m1" [binary]="true"
            (onChange)="checkUncheckAll()"></p-checkbox>
        </th>
        <th style="min-width:200px">Name</th>
        <th style="min-width:250px">Email</th>
        <th style="min-width:150px">Phone Number</th>
        <th style="min-width:250px">Facility Role</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-shareImprove>
      <tr class="p-selectable-row">
        <td style="min-width:50px">
          <p-checkbox [(ngModel)]="shareImprove.isSelected" name="list_name" value="{{shareImprove.id}}" [binary]="true"
            (onChange)="isAllSelected()"></p-checkbox>
        </td>
        <td pTooltip="{{shareImprove.name}}" tooltipPosition="top" style="min-width:200px">{{shareImprove.name}}</td>
        <td pTooltip="{{shareImprove.email}}" tooltipPosition="top" style="min-width:250px">{{shareImprove.email}}</td>
        <td pTooltip="{{shareImprove.phone}}" tooltipPosition="top" style="min-width:150px">{{shareImprove.phone}}</td>
        <td pTooltip="{{shareImprove.label}}" tooltipPosition="top" style="min-width:250px">{{shareImprove.label}}</td>
      </tr>
    </ng-template>
  </p-table>

  <ng-template pTemplate="footer">
    <button pButton type="button" (click)="displayModal=false;ReportPageLoader.value=false" class=" btn-UnCancelCase">
      <i class="pi pi-times"></i>&nbsp; <b>Cancel</b> </button>
    <p-button label="Send Email" styleClass="p-button-text" (click)="DataTransfer('Confirm to Send Email');">
    </p-button>
  </ng-template>
</p-dialog>


<p-dialog header="{{selectedFilterType == 'system' ? 'System' : selectedFilterType == 'facility' ? 'Facility' : 'Regional'}} -
{{selectedOptionText}} - {{SelectedReportType == 'quarterly' ? 'Quarterly': 'Monthly'}} Report" [(visible)]="displayBasic2" [modal]="true" [style]="{width: '70vw'}"
  [draggable]="false" [resizable]="false">
  
  <p-table #dt [value]="facilityMailData" [rows]="take" *ngIf="!noRecordFoundBool"
    styleClass="p-datatable-striped p-datatable-gridlines createRoles" [paginator]="true" sortMode="multiple"
    [lazy]="true" (onLazyLoad)="loadfacilityMailData($event)" responsiveLayout="scroll" [rowHover]="true" dataKey="Id"
    [totalRecords]="totalRecords" [columns]="cols" [resizableColumns]="false"
    styleClass="p-datatable-striped p-datatable-gridlines overflow-x-auto"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [resetPageOnSort]="false"
    [showCurrentPageReport]="true" [rowsPerPageOptions]="[5,10,25,50,totalRecords]" paginatorDropdownAppendTo="body">
    <ng-template pTemplate="header" let-facilityMailData>
      <tr>
        <th>Email</th>
        <th>Sent Date</th>
        <th style="width:15%">Attachment</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-facilityMailData let-rowIndex="rowIndex">
      <tr>
        <td>{{facilityMailData.qitsd_email}}</td>
        <td>{{facilityMailData.qitsd_created_by_date}}</td>
        <td style="width:15%">
          <p-button label="Get PDF" (click)="getPdf(facilityMailData);" id="getPdf"></p-button>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <h3 class="text-center" *ngIf="noRecordFoundBool"><b>No Record Found</b></h3>
  <ng-template pTemplate="footer">
    <p-button icon="pi pi-check" (click)="displayBasic2=false;take=10;skip=0" label="Ok" styleClass="p-button-text">
    </p-button>
  </ng-template>
</p-dialog>
<p-dialog header="Report Page" [(visible)]="reportPageBool" [modal]="true" [draggable]="false" [resizable]="false">
  <ng-template pTemplate="header">
    <span>
      <p-button class="ml-2 p-button-primary report-exportexcal" type="button"
        (click)="labelReportPage.includes('Email') ? SendEmail() : exportToPdf()" [loading]="ReportPageLoader.value"
        label="{{labelReportPage}}"></p-button>
      <p-button *ngIf="!labelReportPage.includes('Email') && !roleForFacility" class="ml-2 p-button-primary report-exportexcal"
        type="button" (click)="exportToWordImproveTemplate();" [loading]="sharedWordLoader" label="Export Word">
      </p-button>
    </span>

  </ng-template>
  <p *ngIf="reportPageBool">
    <app-report-template></app-report-template>
  </p>
  <ng-template pTemplate="footer">
    <button pButton type="button" (click)="reportPageBool=false;ReportPageLoader.value=false" class=" btn-UnCancelCase">
      <i class="pi pi-times"></i>&nbsp; <b>Cancel</b> </button>
  </ng-template>
</p-dialog>
